export default {
    url: '/portal',
    template: '<manage-permissions-users-list-all></manage-permissions-users-list-all>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/list/all/index.js